import { render, staticRenderFns } from "./Item-Table-Old.vue?vue&type=template&id=56cf7559&"
import script from "./Item-Table-Old.vue?vue&type=script&lang=js&"
export * from "./Item-Table-Old.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/surex/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56cf7559')) {
      api.createRecord('56cf7559', component.options)
    } else {
      api.reload('56cf7559', component.options)
    }
    module.hot.accept("./Item-Table-Old.vue?vue&type=template&id=56cf7559&", function () {
      api.rerender('56cf7559', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Item-Table-Old.vue"
export default component.exports